import React from "react";

import {Breadcrumb, Button, Card, Col, Form, Spin, Steps} from 'antd';
import useController from "./CreateUpdateCompanyDialog.controller";
import FirstStepCompany from "./components/FirstStepCompany";
import SecondStepRepresentative from "./components/SecondStepRepresentative";
import ThirdStepProducts from "./components/ThirdStepProducts";
import StyledContainer from "./CreateUpdateCompanyDialog.style";
import {Link, withRouter} from "react-router-dom";
import LeftOutlined from "@ant-design/icons/es/icons/LeftOutlined";
import CompanySuccessDialog from "./components/CompanySuccessDialog";

const CreateUpdateCompanyDialog = ({location: {pathname}, history}) => {

    const {
        current, newCompany, goToAddLicencesForCompany, goToCompanies, softwareProducts, stepsThatHaveError, next, prev, onChange, isDeviceSmall, darkMode, primaryColor, editMode, onSubmit, stepForm, companySavePending,
        initialValues, initialValuesLoadingInEditMode, clearNewlyAddedCompany, onProductsChange
    } = useController({pathname, history});

    const {Step} = Steps;

    const steps = [
        {
            step: 0,
            title: 'Company',
            description: 'Fill in company data',
            content: FirstStepCompany,
        },
        {
            step: 1,
            title: 'Representative',
            description: 'Fill in representative data',
            content: SecondStepRepresentative({darkMode}),
        },
        {
            step: 2,
            title: 'Products (optional)',
            description: 'Add products for Company',
            content: ThirdStepProducts({softwareProducts, onProductsChange, editMode, initialValues, darkMode}),
        },
    ];

    const layout = {
        labelCol: {span: 8},
        wrapperCol: {span: 16}
    };

    const stepsProperties = isDeviceSmall ? {direction: 'vertical', size: 'small'} : {};

    const renderForm = () => <Form initialValues={initialValues} form={stepForm} {...layout}>
        <Steps current={current} {...stepsProperties} onChange={onChange}>
            {steps.map(item => (
                <Step status={stepsThatHaveError.indexOf(item.step) !== -1 ? 'error' : null}
                      disabled={companySavePending} key={item.title} title={item.title}
                      description={item.description}/>
            ))}
        </Steps>

        {steps.map(({step, content}) =>
            (<div key={step.toString()} className={`steps-content ${step !== current && "hidden"}`}>
                {content}
            </div>))}

        <div className="steps-action">
            <Col offset={8} span={16}>
                {current < steps.length - 1 && (
                    <Button type="primary" onClick={() => next()}>
                        Next
                    </Button>
                )}
                {current === steps.length - 1 && (
                    <Button loading={companySavePending} type="primary" onClick={() => onSubmit()}>
                        Save
                    </Button>
                )}
                {current > 0 && (
                    <Button disabled={companySavePending} style={{margin: '0 8px'}}
                            onClick={() => prev()}>
                        Previous
                    </Button>
                )}
            </Col>
        </div>
    </Form>;

    return (
        <StyledContainer darkMode={darkMode} primaryColor={primaryColor}>
            <Breadcrumb>
                <Breadcrumb.Item><Link to={'/company'}><LeftOutlined/> Back to Companies</Link></Breadcrumb.Item>
            </Breadcrumb>
            <Card title={editMode ? 'Edit Company' : 'Add New Company'}>

            {
                newCompany ?
                    <CompanySuccessDialog clearNewlyAddedCompany={clearNewlyAddedCompany} newCompany={newCompany}
                                          goToCompanies={goToCompanies}
                                          goToAddLicencesForCompany={goToAddLicencesForCompany}/> :

                    (editMode && initialValuesLoadingInEditMode ? <Spin tip="Loading...">
                        {
                            renderForm()
                        }
                    </Spin> : renderForm())

            }
            </Card>
        </StyledContainer>
    );
};

export default withRouter(CreateUpdateCompanyDialog);